import {getLang} from "../utils/user";

let isZh = getLang() === "zh"

export const activeDaysOptions = [0, 1, 2, 3, 5, 7, 15, 30].map(day => ({ label : day === 0 ? (isZh ? "不限" : "All") : day + (isZh ? "天" : "days"), value: day }));
export const genderOptions = [{label: isZh ? "不限" : "All", value: 0}, {label : isZh ? "男" : "Male", value : 1}, {label : isZh ? "女" : "Female", value: 2}]
export const ageOptions = [0, 15, 20, 25,30,35,40,45,50,55,60,65,70,75,80].map(day => ({ label : day === 0 ? (isZh ? "不限" : "All") : day + (isZh ? "岁" : "years old"), value: day }));

export const detectionStateEnum = {
    0: { text: "未知", status: "Warning"},
    1: { text: '活跃号', status: 'Success'},
    2: { text: '空号', status: 'Error' },
    3: { text: '沉默号', status: 'Default' },
    4: { text: '风险号', status: 'Warning' },
    5: { text: '白名单', status: 'Success' },
    6: { text: '黑名单', status: 'Error' },
    7: { text: '未注册', status: 'Success' },
    8: { text: '已激活', status: 'Error' },
    9: {text: '正常', status: 'Success'},
    10: {text: '空号', status: 'Error'},
    11: {text: '通话中', status: 'Default'},
    12: {text: '不在网', status: 'Default'},
    13: {text: '关机', status: 'Default'},
    14: {text: '无短信能力', status: 'Default'},
    15: {text: '欠费', status: 'Default'},
    16: {text: '长时间关机', status: 'Default'},
    17: {text: '非携号', status: 'Success'},
    18: {text: '携移', status: 'Default'},
    19: {text: '携联', status: 'Default'},
    20: {text: '携电', status: 'Default'},
    21: {text: '男', status: 'Success'},
    22: {text: '女', status: 'Default'},
    23: {text: '活跃', status: 'Success'},
    24: {text: '非活跃', status: 'Default'},
    25: {text: '非封号', status: 'Success'},
    26: {text: '封号', status: 'Default'},
    27: {text: '未开通', status: 'Success'},
    28: {text: '已开通', status: 'Default'},
    29: {text: '未知', status: 'Warning'},
    30: {text: '高质量', status: 'Success'},
    31: {text: '活跃', status: 'Success'},
    32: {text: '普通', status: 'Default'},
    33: {text: '小米', status: 'Default'},
    34: {text: 'OPPO', status: 'Default'},
    35: {text: 'VIVO', status: 'Default'},
    36: {text: '活跃', status: 'Default'},
    37: {text: '普通', status: 'Default'},
    38: {text: '风险', status: 'Default'},
    39: {text: 'IOS', status: 'Default'},
    40: {text: '荣耀', status: 'Default'},
    41: {text: 'VIVO', status: 'Default'},
    42: {text: 'OPPO', status: 'Default'},
    43: {text: '小米', status: 'Default'},
    44: {text: '华为', status: 'Default'},
    45: {text: '其它', status: 'Default'},
}

export const detectionStateOptions = [
    {value: 1, label: '活跃号(实号)'},
    {value: 2, label: '空号'},
    {value: 3, label: '沉默号'},
    {value: 4, label: '风险号'},
    {value: 5, label: '白名单'},
    {value: 6, label: '黑名单'},
    {value: 7, label: '未注册'},
    {value: 8, label: '已激活'},
    {value: 9, label: '正常'},
    {value: 10, label: '空号'},
    {value: 11, label: '通话中'},
    {value: 12, label: '不在网'},
    {value: 13, label: '关机'},
    {value: 14, label: '无短信能力'},
    {value: 15, label: '欠费'},
    {value: 16, label: '长时间关机'},
    {value: 17, label: '非携号'},
    {value: 18, label: '携移'},
    {value: 19, label: '携联'},
    {value: 20, label: '携电'},
    {value: 21, label: '男'},
    {value: 22, label: '女'},
    {value: 23, label: '活跃'},
    {value: 24, label: '非活跃'},
    {value: 25, label: '非封号'},
    {value: 26, label: '封号'},
    {value: 27, label: '未开通'},
    {value: 28, label: '已开通'},
    {value: 29, label: '未知'},
    {value: 30, label: '高质量'},
    {value: 31, label: '活跃'},
    {value: 32, label: '普通'},
    {value: 33, label: '小米'},
    {value: 34, label: 'OPPO'},
    {value: 35, label: 'VIVO'},
    {value: 36, label: '活跃'},
    {value: 37, label: '普通'},
    {value: 38, label: '风险'},
    {value: 39, label: 'IOS'},
    {value: 40, label: '荣耀'},
    {value: 41, label: 'VIVO'},
    {value: 42, label: 'OPPO'},
    {value: 43, label: '小米'},
    {value: 44, label: '华为'},
    {value: 45, label: '其它'},
]

export const detectionWayEnum = {
    1: { text: '本地检测', status: 'Default'},
    2: { text: 'API检测', status: 'Success' },
    3: { text: '聚合检测', status: 'Warning'}
}

export const detectionStatusEnum = {
    0: { text: isZh ? '待检测' : 'To Be Sieve', status: 'Default'},
    1: { text: isZh ? '检测中' : 'Sieving', status: 'Processing'},
    2: { text: isZh ? '检测成功': 'Sieve Success', status: 'Success' },
    3: { text: isZh ? '检测失败': 'Sieve Fail', status: 'Error'},
    9: { text: isZh ? '检测关闭': 'Sieve Closed', status: 'Warning'}
}

export const detectionUserStatusEnum = {
    0: { text: isZh ? '待检测' : 'To Be Sieve', status: 'Default'},
    1: { text: isZh ? '检测中' : 'Sieving', status: 'Processing'},
    2: { text: isZh ? '检测成功': 'Sieve Success', status: 'Success' },
    3: { text: isZh ? '检测失败': 'Sieve Failed', status: 'Error'}
}

export const apiRequestStateEnum = {
    0: { text: '未提交', status: 'Default'},
    1: { text: '提交成功', status: 'Success' },
    2: { text: '提交失败', status: 'Error'},
    3: { text: '查询成功', status: 'Success' },
    4: { text: '查询失败', status: 'Error'}
}

export const balanceGiveStateEnum = {
    1: { text: '正常', status: 'Success' },
    2: { text: '已使用', status: 'Default'},
    3: { text: '已过期', status: 'Error' }
}

export const internationalBalanceTypeNum = {
    1: { text: '充值', status: 'Default' },
    2: { text: '扣除', status: 'Default'},
    3: { text: '消耗', status: 'Default' },
    4: { text: '失败返还', status: 'Default' },
    5: { text: '代理商返利', status: 'Default' }
}

export const balanceTypeNum = {
    1: { text: '充值', status: 'Default' },
    2: { text: '扣除', status: 'Default'},
    3: { text: '消耗', status: 'Default' },
    4: { text: '失败返还', status: 'Default'}
}

export const userStatusEnum = {
    1: {
        text: '正常',
        status: 'Success',
    },
    2: {
        text: '冻结/不可用',
        status: 'Error',
    },
}

export const authenticationStatusMap = {
    0 : {text: "未认证", color: "gray", status: 'Default'},
    1 : {text: "认证中", color: "blue", status: 'Default'},
    2 : {text: "已认证", color: "green", status: 'Success'},
    3 : {text: "驳回认证", color: "volcano", status: "Error"}
}

export const authenticationExemptMap = {
    0 : {text: "需认证", status: 'Default'},
    1 : {text: "免认证", status: 'Success'}
}


export const productVisibleMap = {
    1 : {text: "一直显示", status: 'Success'},
    2 : {text: "仅客户开通后显示", status: 'Default'},
    3 : {text: "一直隐藏", status: 'Warning'}
}

export const submitTypeMap = {
    1 : {text: "单条提交（同步结果）", status: 'Default'},
    2 : {text: "多条提交（同步结果）", status: 'Default'},
    3 : {text: "文件提交（异步结果）", status: 'Default'}
}
export const submitTypeOptions = [
    {value: 1 , label : "单条提交（同步结果）"},
    {value: 2 , label : "多条提交（同步结果）"},
    {value: 3 , label : "文件提交（异步结果）"}
]

export const detectionWayOptions = [
    {value: 1 , label : "聚合检测"},
    {value: 2 , label : "仅本地库"},
    {value: 3 , label : "仅API"}
]

export const apiStatusMap = {
    1: {text: '正常', status: 'Success'},
    2: {text: '暂停', status: 'Error'},
    3: {text: '维护中', status: 'Processing'},
}

export const randomPhoneStatusMap = {
    1: {text: isZh ? '生成中' : 'Generating', status: 'Processing'},
    2: {text: isZh ? '生成成功' : 'Generated', status: 'Success'},
    3: {text: isZh ? '已检测' : 'Filtered', status: 'Default'},
    4: {text: isZh ? "生成失败" : "Failed to generate", status: 'Error'}
}

export const localStoreMap = {
    1: {text: '并入本地库', status: 'Success'},
    0: {text: '仅检测，不并入', status: 'Default'}
}

export const localStoreOptions = [
    {value : 1, label :'并入本地库'},
    {value : 0, label :'仅检测，不并入'}
]

export const upkeepTypeEnum = {
    1: {text: '自动维护', status: 'Success'},
    0: {text: '人工维护', status: 'Default'}
}

export const warningTypeEnum = {
    1: {text: '余额异常', status: 'Error'},
    2: {text: '登录异常', status: 'Default'},
    3: {text: '自动充值异常', status: 'Warning'}
}

export const liftStatusEnum = {
    1: {text: '等待处理', status: 'Processing'},
    2: {text: '已处理', status: 'Success'},
}

export const upkeepTypeOptions = [
    {label: "自动维护", value: 1},
    {label: "人工维护", value: 0}
]
export const AUTH = {
    ADMIN : 1,
    AGENT : 2,
    USER : 3,
    SUPER_ADMIN : 9
}

export const hotOptions = {
    1: {text: "热门", value: 1},
    //0: {text: "非热门", value: 0}
}

export const selfToolOptions = {
    1 : {text: "平台工具", value: 1},
    //0 : {text: "外链", value: 0}
}
